import { object, boolean, number } from 'zod';

const BackendPersistedDataSchema = object({
  hasFeedAccess: boolean().default(false),
  hasDismissedNewPostFeatureBanner: boolean().default(false),
  version: number().int().min(1)
}).strict();
const DefaultBackendPersistedDataSchema = {
  hasFeedAccess: false,
  hasDismissedNewPostFeatureBanner: false,
  version: 1
};

export { BackendPersistedDataSchema, DefaultBackendPersistedDataSchema };
